import { showToast } from '~/utils'

const getActionName = (type) => type?.replace(/[^/]+\/([^/]+)\/[^/]+/, '$1')
const removePendingRequest = (state, params) => {
  const name = getActionName(params.type)
  const requestId = params.meta.requestId
  if (state.pendingRequests[name][requestId]) {
    delete state.pendingRequests[name][requestId]
    if (Object.keys(state.pendingRequests[name]).length === 0) {
      delete state.pendingRequests[name]
    }
  }
}

const buildExtraReducers = (builder, definitions) => {
  return definitions.forEach(([method, fulfilled, rejected = true]) => {
    builder.addCase(method.pending, (state, params) => {
      const name = getActionName(params.type)
      const requestId = params.meta.requestId
      if (!state.pendingRequests[name]) {
        state.pendingRequests[name] = {}
      }
      state.pendingRequests[name][requestId] = new Date().valueOf()
    })
    if (typeof fulfilled === 'function') {
      builder.addCase(method.fulfilled, (state, result) => {
        removePendingRequest(state, result)
        fulfilled(state, result)
      })
    } else {
      builder.addCase(method.fulfilled, (state, result) => {
        removePendingRequest(state, result)
        if (fulfilled) {
          state[fulfilled] = result.payload
        }
      })
    }
    if (typeof rejected === 'function') {
      builder.addCase(method.rejected, (state, result) => {
        removePendingRequest(state, result)
        rejected(state, result)
      })
    } else if (typeof fulfilled !== 'function') {
      builder.addCase(method.rejected, (state, result) => {
        removePendingRequest(state, result)
        if (result?.error?.name === 'AbortError') return
        if (fulfilled) {
          state[fulfilled] = { error: result.payload }
        }
        if (result?.error) {
          // throw result.error
          showToast(result.error.message, { variant: 'error' })
        }
      })
    }
  })
}

export default buildExtraReducers
